/**
 * Convert a string into a DocumentFragment.
 */



export const html = (str: string) => {
    const elt = document.createElement('template');
    elt.innerHTML = str;
    return elt.content;
};
